import { createElement } from "react";
import * as styledComponents from "styled-components";
import lightTheme from "../../theme/themes/default";
const { default: styled, createGlobalStyle, css, keyframes, useTheme: useOriginalTheme, ThemeProvider: OriginalThemeProvider, } = styledComponents;
export const generateMediaQuery = (theme) => {
    const { breakpoints } = theme;
    return Object.keys(breakpoints).reduce((helper, name) => {
        const size = breakpoints[name];
        helper[name] = ((strings, ...interpolations) => {
            return css `
        @media (min-width: ${size}) {
          ${css(strings, ...interpolations)}
        }
      `;
        });
        return helper;
    }, {});
};
export const useUITheme = () => {
    const theme = useOriginalTheme();
    return Object.assign({}, theme._ui);
};
export const ThemeProvider = ({ theme = lightTheme, children }) => {
    const screen = getScreens(theme);
    return createElement(OriginalThemeProvider, { theme: { _ui: Object.assign(Object.assign({}, theme), { screen }) } }, children);
};
/**
 * This util is used to provide helper functions for the screen responsive
 * layout.
 *
 * @param theme - Current theme of the application
 * @returns - Screen helper functions
 */
export const getScreens = (theme) => {
    /**
     * This function is used to get media screen query string base on provided
     * breakpoint. It's normally used when styling in styled components.
     *
     * @returns String with a css media screen query to be used in styling
     */
    const above = generateMediaQuery(theme);
    /**
     * This function is used to get max-width media query string base on provided
     * breakpoint. It's mainly used together with useMediaQuery hook.
     *
     * @param breakpoint Target that it should be below
     * @returns String with a CSS media screen query to be used in styling
     */
    const belowQueryString = (breakpoint) => breakpoint && `(max-width: ${theme.breakpoints[breakpoint]})`;
    /**
     * This function is used to get min-width media query string base on provided
     * breakpoint. It's mainly used together with useMediaQuery hook.
     *
     * @param breakpoint Target that it should be above
     * @returns String with a css media screen query to be used in styling
     */
    const aboveQueryString = (breakpoint) => breakpoint && `(min-width: ${theme.breakpoints[breakpoint]})`;
    return {
        above,
        belowQueryString,
        aboveQueryString,
    };
};
export default styled;
export { createGlobalStyle, css, keyframes };
